import { FC } from 'react';

import WalletTransferLayout from 'wallet-transfer/components/layouts/wallet-transfer-layout';

import RoutesWithNotFound from 'common/config/routes/routesWithNotFound.util';

interface Props {
  children: JSX.Element[] | JSX.Element;
}

const WalletTransferRouting: FC<Props> = ({ children }) => {
  return (
    <WalletTransferLayout>
      <RoutesWithNotFound>{children}</RoutesWithNotFound>
    </WalletTransferLayout>
  );
};
export default WalletTransferRouting;
